import React from 'react';
import {Button} from '@material-ui/core';
import {isEmail} from 'validator';
import {withFormik} from 'formik';
import {isEmpty} from 'lodash/lang';
import {FormControl, FormGroup, FormHelperText, Grid} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import {PrimaryButton} from '../common/StyledButtons';


const _QuizTakeStartForm = props => {
    const {
        values,
        handleSubmit,
        handleBlur,
        handleChange,
        errors,
        touched
    } = props;
    return (
        <Grid container component="form" onSubmit={handleSubmit}>
            <Grid item xs={12}>
                <FormGroup>
                    <FormControl error={errors.user_name && touched.user_name}>
                        <TextField
                            name="user_name"
                            label="Your Name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            margin="dense"
                            variant="outlined"
                            value={values.user_name}
                        />
                        <FormHelperText
                            error={errors.user_name && touched.user_name}>{errors.user_name}</FormHelperText>
                    </FormControl>
                </FormGroup>
                <FormGroup>
                    <FormControl error={errors.email && touched.email}>
                        <TextField
                            name="email"
                            label="Email"
                            margin="dense"
                            variant="outlined"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        <FormHelperText
                            error={errors.email && touched.email}>{errors.email}</FormHelperText>
                    </FormControl>
                </FormGroup>
                <FormGroup>
                    <FormControl error={errors.platform_user_id && touched.platform_user_id}>
                        <TextField
                            name="platform_user_id"
                            label="User ID"
                            margin="dense"
                            variant="outlined"
                            value={values.platform_user_id}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                        <FormHelperText
                            error={errors.platform_user_id && touched.platform_user_id}>
                            {errors.platform_user_id}
                        </FormHelperText>
                    </FormControl>
                </FormGroup>
            </Grid>
            <Grid item xs={12}>
                <PrimaryButton className="pull-right" type="submit">
                    Start the Quiz
                </PrimaryButton>
            </Grid>
        </Grid>
    );
};


const QuizTakeStartForm = withFormik({
    mapPropsToValues: (props) => ({
        user_name: props.initialValues['user_name'] || '',
        email: props.initialValues['email'] || '',
        platform_user_id: props.initialValues['platform_user_id'] || '',
    }),

    validate: values => {
        let errors = {};
        const email = values.email;
        const userName = values.user_name;
        const platformUserId = values.platform_user_id;
        if (isEmpty(userName)) {
            errors.user_name = 'Please enter your name.';
        }
        if (isEmpty(platformUserId)) {
            errors.platform_user_id = 'Please enter your user ID';
        }
        if (isEmpty(email)) {
            errors.email = 'Please enter your email';
        } else if (!isEmail(email)) {
            errors.email = 'That e-mail does not appear valid.';
        }
        return errors;
    },

    handleSubmit: (values, {setSubmitting, props}) => {
        props.onSubmit(values);
        setSubmitting(false);
    },

    displayName: 'QuizTakeStartForm',
})(_QuizTakeStartForm);

export default QuizTakeStartForm;
